const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://taroguru.github.io',
    gaTrackingId: 'UA-165706088-1',
    trailingSlash: false,
  },
  header: {
    logo: '/logo.jpg',
    logoLink: 'https://taroguru.github.io',
    title: "<a href='https://taroguru.github.io/'>모든 코드는 능히 버그를 가지고 있을지니...</a>",
    githubUrl: 'https://github.com/taroguru',
    tweetText: '',
    helpUrl: '',
    social: `<li>
		    <a href="https://twitter.com/taroguru" target="_blank" rel="noopener">
		      <div class="twitterBtn">
		        <img src='https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/twitter-brands-block.svg' alt={'Twitter'}/>
		      </div>
		    </a>
		  </li>
			<li>
		    <a href="https://discordapp.com/invite/hasura" target="_blank" rel="noopener">
		      <div class="discordBtn">
		        <img src='https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/discord-brands-block.svg' alt={'Discord'}/>
		      </div>
		    </a>
		  </li>`,
    links: [{ text: '', link: '' }],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/introduction', // add trailing slash if enabled above
      '/codeblock',
    ],
    collapsedNav: [
      '/codeblock', // add trailing slash if enabled above
    ],
    links: [{ text: 'GitHub', link: 'https://github.com/taroguru' }],
    frontLine: false,
    ignoreIndex: true,
    title:
      "<a href='https://play.google.com/store/apps/details?id=workshop.soso.jickjicke'>Rala</a><div class='greenCircle'></div><a href='https://github.com/taroguru/rala'>repo</a>",
  },
  siteMetadata: {
    title: 'SDD | Sorry-Driven Development',
    description: '모든 코드는 능히 버그를 가지고 있으니 선빵으로 사과때리고 개발하는 개발자의 기록. 사과 != 애플',
    ogImage: null,
    docsLocation: 'https://github.com/taroguru',
    favicon: 'https://graphql-engine-cdn.hasura.io/img/hasura_icon_black.svg',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Sorry-Driven Development',
      short_name: '',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
